import { addressService } from '../services'
import Vue from 'vue'
import AddressModal from '@/components/modals/AddressModal'

const state = {
  all: {
    filterInitialized: false,
    defaultFilter: {
      projectId: null,
      customerName: null,
      name: null,
      city: null,
      orderByColumn: 'name',
      orderByDescending: false
    },
    currentPage: 1,
    loading: true,
    saving: false,
    items: [],
    filter: {},
    meta: {}
  }
}

const actions = {
  initialize ({ commit }) {
    commit('initialize')
  },

  resetFilter ({ commit }) {
    commit('resetFilter')
  },

  newAddressModal ({ commit }) {
    Vue.prototype.$panel(AddressModal, {})
  },

  getListData ({ commit }) {
    commit('getListDataRequest')

    addressService.getListData(state.all.filter, state.all.currentPage)
      .then(
        data => {
          commit('getListDataSuccess', data.result)
        }
      )
  },

  getById ({ commit }, id) {
    return addressService.getById(id)
  },

  getAll ({ commit }) {
    return addressService.getAll().then(addresses => {
      return addresses.result
    })
  },

  getAddressesByCustomerIdAndType ({ commit }, payload) {
    return addressService.getAddressesByCustomerIdAndType(payload.customerId, payload.addressType).then(addresses => {
      return addresses.result
    })
  },

  getAddressesByProjectId ({ commit }, id) {
    return addressService.getAddressesByProjectId(id)
  },

  getAddressesByCustomerId ({ commit }, id) {
    return addressService.getAddressesByCustomerId(id).then(address => {
      return address.result
    })
  },

  getCustomerAddressesByProjectId ({ commit }, id) {
    return addressService.getCustomerAddressesByProjectId(id).then(address => {
      return address.result
    })
  },

  create ({ commit, dispatch }, address) {
    commit('startSave')
    return addressService.create(address)
      .then(address => {
        commit('endSave')
        commit('createSuccess', address.result)
        dispatch('getListData')
        return address.result
      }).catch(error => {
        commit('endSave')
        commit('createFailure')
        return Promise.reject(error)
      })
  },

  createProjectAddress ({ commit, dispatch }, address) {
    commit('startSave')
    return addressService.createProjectAddress(address)
      .then(address => {
        commit('endSave')
        commit('createProjectAddressSuccess', address.result)
        dispatch('getListData')
        return address.result
      }).catch(error => {
        commit('endSave')
        commit('createProjectAddressFailure')
        return Promise.reject(error)
      })
  },

  update ({ dispatch, commit }, address) {
    commit('startSave')
    return addressService.update(address)
      .then(address => {
        commit('endSave')
        commit('updateSuccess', address.result)
        dispatch('getListData')
        return address.result
      }).catch(error => {
        console.error(error)
        commit('endSave')
        commit('updateFailure')
        return Promise.reject(error)
      })
  },

  delete ({ commit }, id) {
    commit('startSave')
    commit('deleteRequest', id)
    addressService.delete(id)
      .then(address => {
        commit('endSave')
        commit('deleteSuccess', id)
      })
  }
}

const getters = {
  isFilterChanged: state => (route) => {
    // Page should not be considered when comparing
    const currentFilter = Object.assign({}, state.all.filter)
    const defaultFilter = Object.assign({}, state.all.defaultFilter)

    currentFilter.page = null
    defaultFilter.page = null

    return !Vue.lodash.isEqual(currentFilter, defaultFilter)
  }
}

const mutations = {
  resetFilter (state) {
    state.all.currentPage = 1
    state.all.filter = Object.assign({}, state.all.defaultFilter)
  },

  initialize (state) {
    if (!state.all.filterInitialized) {
      mutations.resetFilter(state)
      state.all.filterInitialized = true
    }
  },

  startSave (state) {
    state.all.saving = true
  },

  endSave (state) {
    setTimeout(() => {
      state.all.saving = false
    }, 200)
  },

  // Get all
  getListDataRequest (state) {
    state.all.loading = true
  },

  getListDataSuccess (state, data) {
    state.all.items = data.items
    state.all.meta = data.meta
    state.all.loading = false
  },

  getListDataFailure (state, error) {
    state.all.error = error
    state.all.loading = false
  },

  // Create
  createSuccess (state, updatedAddress) {
    /*
    state.all.items = state.all.items.map(customer =>
      customer.customerId === updatedcustomer.customerId ? updatedcustomer : customer
    )
    */
    Vue.prototype.$toast('Adress skapad', 'success')
  },

  createFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa adressen', 'error')
  },

  createProjectAddressSuccess (state, updatedAddress) {
    Vue.prototype.$toast('Projektkoppling skapad', 'success')
  },

  createProjectAddressFailure (state, error) {
    Vue.prototype.$toast('Kunde inte skapa den nya projekkopplingen', 'error')
  },

  // Update
  updateSuccess (state, updatedAddress) {
    Vue.prototype.$toast('Adress uppdaterad', 'success')

    /*
    if (!state.all.items || state.all.items.length === 0) {
      return
    }
    state.all.items = state.all.items.map(address =>
      address.addressId === updatedAddress.addressId ? updatedAddress : address
    )
    */
  },

  updateFailure (state) {
    Vue.prototype.$toast('Kunde inte uppdatera adressen', 'error')
  },

  // Delete
  deleteRequest (state, id) {
    // add 'deleting:true' property to customer being deleted
    state.all.items = state.all.items.map(address =>
      address.addressId === id
        ? { ...address, deleting: true }
        : address
    )
  },

  deleteSuccess (state, id) {
    // remove deleted customer from state
    state.all.items = state.all.items.filter(address => address.addressId !== id)
  }
}

export const addresses = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/address.module.js